<h2 mat-dialog-title>
  <mat-icon>bookmark</mat-icon>
  {{catalogue}} | {{ contractData?.name }}
</h2>

<mat-dialog-content class="mat-typography">
  <div class="actions-container">
    <button mat-raised-button color="primary" matTooltip="Actualizar" matTooltipPosition="right" [disabled]="!createBtn" (click)="getEntityData()">
      <mat-icon>refresh</mat-icon>
    </button>
    <!--<button *ngIf="permissions['create'] === true" mat-raised-button [disabled]="!createBtn" (click)="openDialog('create')"><mat-icon>add</mat-icon>Crear {{cat}}</button>-->
    @if (permissions['create'] === true) {
      <button mat-raised-button [disabled]="!createBtn" (click)="openDynamicDialog('create')"><mat-icon>add</mat-icon>Agregar {{cat}}</button>
    }

    <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Más">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      @if (permissions['create'] === true) {
        <button mat-menu-item (click)="downloadSampleFile()"><mat-icon>description</mat-icon>Archivo muestra (Carga xlsx)</button>
      }
      @if (permissions['create'] === true) {
        <button mat-menu-item (click)="openUploadFile()"><mat-icon>upload</mat-icon>Cargar archivo (xlsx)</button>
      }
      <button mat-menu-item (click)="downloadFile()"><mat-icon>download</mat-icon>Descargar archivo (xlsx)</button>
    </mat-menu>

    <app-search-pill (search)="applyFilter($event)"></app-search-pill>
  </div>

  <!-- Mensaje cuando no hay procedimientos -->
  @if (!hasData) {
    <div class="empty-state">
      <mat-icon class="empty-icon">info</mat-icon>
      <h3>No hay {{catalogue}} asignados</h3>
      <p>Agregue {{catalogue}} al contrato usando el botón "Agregar {{cat}}"</p>
    </div>
  }

  <!-- Tabla de procedimientos -->
  @if (hasData) {
    <div>
      <!-- INDICADORES -->
      <div class="indicators">
        <div class="dark-status">
          <span>
            <b>Total: {{ dataSource ? (dataSource.filteredData?.length || 0) : 0 }}</b>
          </span>
        </div>
        <mat-paginator
          [pageSize]="5"
          [pageSizeOptions]="[5, 20, 50]"
          showFirstLastButtons>
        </mat-paginator>
      </div>
      <!-- TABLA -->
      @if (dataSource) {
        <div class="table-container mat-elevation-z8">
          <table mat-table [dataSource]="dataSource">
            @for (key of keys; track key; let i = $index) {
              <!-- COLUMNA MORE -->
              @if (key === 'more') {
                <ng-container matColumnDef="more">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element; let rowIndex = index">
                    @if (permissions?.update === true) {
                      <button
                        mat-icon-button
                        color="primary"
                        matTooltip="Editar {{ cat }}"
                        (click)="openDynamicDialog('update', element)">
                        <mat-icon>edit</mat-icon>
                      </button>
                    }
                    @if (permissions?.delete === true) {
                      <button
                        mat-icon-button
                        color="warn"
                        matTooltip="Eliminar {{ cat }}"
                        (click)="deleteRecord(element, rowIndex)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    }
                  </td>
                </ng-container>
              }
              <!-- COLUMNAS NORMALES -->
              @if (key !== 'more') {
                <ng-container [matColumnDef]="key">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ keyNames?.[i] || key }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{
                    key === 'name' ||
                    key === 'location' ||
                    key === 'type' ||
                    key === 'itemNumber'||
                    key === 'description'
                    ? element?.[key]
                    : element?.['_' + key] ?? 'N/A'
                    }}
                  </td>
                </ng-container>
              }
            }
            <tr mat-header-row *matHeaderRowDef="keys; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: keys"></tr>
          </table>
        </div>
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-raised-button
    (click)="close()">
    Cancelar
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="saveChanges()"
    [disabled]="dataList.length === 0">
    <mat-icon>save</mat-icon> Guardar Cambios
  </button>
</mat-dialog-actions>